import React, {useState, useEffect, useContext} from 'react';
import {useTranslation} from 'react-i18next';

import NotFound from '../../../NotFound';
import InputFilter from '../../../Filters/InputFilter';
import SelectComponent from '../../../Selects/SelectFilter';
import Datepicker from 'react-tailwindcss-datepicker';
import moment from 'moment';

import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import {getCategoriasReunioes, getEstabelecimentos, getRepresentantes, getVisitas} from '../../../../pages/requests';
import axios from 'axios';
import {Context} from '../../../../Helpers/Auth';
import TablePagination from '../../../TablePagination';
import {toast} from 'react-toastify';

function HistoricoVisitas({info}) {
    const FORMATO_DATA = 'YYYY-MM-DD';
    const ITEMS_PER_PAGE = 15;
    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const {t} = useTranslation();

    const {
        prospect,

        utilizador,
        filtroCodigo,
        setFiltroCodigo,
        filtroEstabHistorico,
        setFiltroEstabHistorico,
        filtroCategoria,
        setFiltroCategoria,
        filtroDtInicio,
        setFiltroDtInicio,
        filtroDtFim,
        setFiltroDtFim,
        filtroRepHistorico,
        setFiltroRepHistorico,
        categorias,
        setCategorias,
        setEstabelecimentos,
        estabelecimentos,
        setRepresentantes,
        representantes,
    } = info;
    const [semDadosEstado, setSemDadosEstado] = useState(false);
    const [semDados, setSemDados] = useState(false);

    const [formattedDateI, setFormattedDateI] = useState('');
    const [formattedDateF, setFormattedDateF] = useState('');

    const [historicoVisitas, setHistoricoVisitas] = useState([]);

    const [isMobile, setIsMobile] = useState(false);
    const [loading, setLoading] = useState(false);

    const {isCard, openCards} = useContext(Context);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRegistos, setTotalRegistos] = useState(0);

    const handleResize = () => {
        setIsMobile(window.innerWidth < 900);
    };

    // // FILTROS

    // const [filtroCodigo, setFiltroCodigo] = useState('');
    // const [filtroEstabHistorico, setFiltroEstabHistorico] = useState('');
    // const [filtroCategoria, setFiltroCategoria] = useState('');
    // const [filtroDtInicio, setFiltroDtInicio] = useState({
    //     startDate: '',
    //     endDate: '',
    // });
    // const [filtroDtFim, setFiltroDtFim] = useState({
    //     startDate: '',
    //     endDate: '',
    // });
    // const [filtroRepHistorico, setFiltroRepHistorico] = useState('');

    // ARRAYS

    //   const [categorias, setCategorias] = useState([]);
    //   const [estabelecimentos, setEstabelecimentos] = useState([]);
    //   const [representantes, setRepresentantes] = useState([]);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);

        const controller = new AbortController();
        const signal = controller.signal;

        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
        setHistoricoVisitas([]);
        setLoading(true);

        debugger;
        getVisitas(
            indexOfFirstItem,
            indexOfLastItem - 1,
            lang,
            signal,
            filtroDtInicio.startDate ?? '',
            filtroDtFim.startDate ?? '',
            prospect.codigoCliente,
            '', //filtroNegocio,
            filtroEstabHistorico?.value ?? '',
            filtroRepHistorico ? [filtroRepHistorico.value] : [],
            filtroCategoria ? [filtroCategoria.value] : [],
            '', //filtroDescricao,
            filtroCodigo,
            false,
        )
            .then(res => {
                if (res.data.success) {
                    setHistoricoVisitas(res.data.reunioes);
                    setTotalRegistos(res.data.totalprodutos);
                } else {
                    res.data.errorMessages.map(m =>
                        toast.error(m, {
                            position: 'top-right',
                            autoClose: 5000,
                        }),
                    );
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.log(error);
                }
            })
            .finally(() => {
                setLoading(false);
            });

        return () => {
            controller.abort();
        };
    }, [currentPage, filtroDtInicio, filtroDtFim, filtroCodigo, /*filtroNegocio,*/ filtroEstabHistorico, filtroCategoria, filtroRepHistorico]);

    useEffect(() => {
        getRepresentantes(lang).then(res => {
            setRepresentantes(res.data.representantes);
        });

        getCategoriasReunioes(lang).then(res => {
            setCategorias(res.data.categorias);
        });

        getEstabelecimentos(lang).then(res => {
            setEstabelecimentos(res.data.estabelecimentos);
        });
    }, []);

    function handleChangeFiltro() {
        if (filtroDtInicio.startDate || filtroDtFim.startDate || filtroCodigo || /*filtroNegocio ||*/ filtroEstabHistorico || filtroCategoria || filtroRepHistorico) {
            return true;
        } else {
            return false;
        }
    }

    function limparFiltros(params) {
        setCurrentPage(1);
        setFiltroDtInicio({startDate: null, endDate: null});
        setFiltroDtFim({startDate: null, endDate: null});
        setFiltroCodigo('');
        //setFiltroNegocio('');
        setFiltroEstabHistorico(null);
        setFiltroCategoria(null);
        setFiltroRepHistorico(null);
    }

    useEffect(() => {
        if (historicoVisitas.length != 0) {
            setSemDados(false);
        } else {
            setSemDados(true);
        }
    }, [historicoVisitas]);

    return (
        <>
            <div>
                {isMobile || isCard ? (
                    <div>
                        {historicoVisitas?.map((elemento, index) => (
                            <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                                <h2 className="mb-0" id="headingOne">
                                    <button
                                        className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                        type="button"
                                        data-te-collapse-init
                                        data-te-collapse-collapsed
                                        data-te-target={'#flush-collapseThree' + index}
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThree">
                                        <div className="flex flex-row">
                                            {elemento.id} | {elemento.categoria.label} | {moment(elemento.dataI).format(FORMATO_DATA)}
                                        </div>
                                        <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                            </svg>
                                        </span>
                                    </button>
                                </h2>
                                <div
                                    id={'flush-collapseThree' + index}
                                    className={openCards ? 'visible' : '!visible hidden'}
                                    data-te-collapse-item
                                    aria-labelledby="flush-headingThree"
                                    data-te-parent="#accordionFlushExample">
                                    <div className="px-5 py-4">
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('estabelecimento')}:</div> {elemento.estabelecimento}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('categoria')}: </div> {elemento.categoria.label}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('dataInicio')}: </div> {moment(elemento.dataI).format(FORMATO_DATA)}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('dataFim')}: </div> {moment(elemento.dataF).format(FORMATO_DATA)}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('representante')}: </div> {elemento.representante?.label}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}

                        {/* {loading && (
                            <div className="flex flex-row mt-14 justify-center">
                                <>
                                    <Spinner />
                                </>
                            </div>
                        )} */}

                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalRegistos / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalRegistos}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            <TablePagination total={totalRegistos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                        </nav>

                        <div className="mb-4">{semDados && <NotFound frase={t('semRegistos')} />}</div>
                    </div>
                ) : (
                    <div className="relative mt-10 min-h-[400px] overflow-x-auto shadow-md sm:rounded-[8px]">
                        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                                <tr>
                                    <th scope="col" className="px-6 py-3">
                                        {t('codigo')}
                                        <InputFilter
                                            onSearch={value => {
                                                setFiltroCodigo(value);
                                            }}
                                        />
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        {t('estabelecimento')}
                                        <SelectComponent
                                            options={estabelecimentos}
                                            value={filtroEstabHistorico ? filtroEstabHistorico.label : ''}
                                            onChange={e => {
                                                setFiltroEstabHistorico(e.label);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                    </th>

                                    <th scope="col" className="px-6 py-3">
                                        {t('categoria')}
                                        <SelectComponent
                                            options={categorias}
                                            value={filtroCategoria ? filtroCategoria.label : ''}
                                            onChange={e => {
                                                setFiltroCategoria(e.label);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        {t('dataInicio')}
                                        <Datepicker
                                            displayFormat={FORMATO_DATA}
                                            useRange={false}
                                            asSingle={true}
                                            value={filtroDtInicio}
                                            onChange={newValue => {
                                                setFiltroDtInicio(newValue);
                                            }}
                                            inputClassName={`rounded-[8px] w-full bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                        />
                                    </th>
                                    <th scope="col" className="px-6 py-3 ">
                                        {t('dataFim')}
                                        <Datepicker
                                            displayFormat={FORMATO_DATA}
                                            useRange={false}
                                            asSingle={true}
                                            value={filtroDtFim}
                                            onChange={newValue => {
                                                setFiltroDtFim(newValue);
                                            }}
                                            inputClassName={`rounded-[8px] w-full bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                        />
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        {t('representante')}
                                        <div className="flex flex-row">
                                            <SelectComponent
                                                options={representantes}
                                                value={filtroRepHistorico ? filtroRepHistorico.label : ''}
                                                onChange={e => {
                                                    setFiltroRepHistorico(e.label);
                                                }}
                                                noOptionsMessage={t('semopcoes')}
                                                placeholder={t('filtro')}
                                            />
                                            {handleChangeFiltro() ? (
                                                <button
                                                    onClick={limparFiltros}
                                                    type="button"
                                                    className="flex items-center border-gray-300 text-gray-600 hover:text-blue-600 bg-gray-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] ml-2 text-xs  text-center dark:bg-gray-600 dark:text-white dark:hover:text-blue-500 dark:focus:ring-blue-800">
                                                    <FilterAltOffIcon />
                                                </button>
                                            ) : null}
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {historicoVisitas.map(elemento => (
                                    <tr className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 ">
                                        <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            {elemento.id}
                                        </th>
                                        <td className="px-6 py-1">{elemento.estabelecimento.label}</td>
                                        <td className="px-6 py-1">{elemento.categoria.label}</td>
                                        <td className="px-6 py-1">{moment(elemento.dataI).format(FORMATO_DATA)}</td>
                                        <td className="px-6 py-1">{moment(elemento.dataF).format(FORMATO_DATA)}</td>
                                        <td className="px-6 py-1">{elemento.representante?.label}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="mb-4">{semDados && <NotFound frase={t('semRegistos')} />}</div>
                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalRegistos / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalRegistos}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            <TablePagination total={totalRegistos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                        </nav>
                    </div>
                )}
            </div>
        </>
    );
}

export default HistoricoVisitas;
